/* ============================================================
   SearchBar — 공통 헤더 검색바 (모든 view 공통, 2026-05-12 격상)
   2026-05-13 App.tsx 분리
   ============================================================ */
import { ICONS } from '../../icons'

export function SearchBar() {
  return (
    <div className="search-bar">
      {ICONS.Search()}
      <input type="text" placeholder="전체 게시판 검색 — 테이블명·라벨·설명" />
      <span className="kbd">⌘K</span>
    </div>
  )
}
